import { afterNextRender, Component, forwardRef, input, linkedSignal, output, signal } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CSSValuePipe } from '@pipes/css-value-pipe';
import { AbstractControl } from '@shared/controls/abstract-control/abstract-control';

@Component({
  selector: 'app-switch',
  standalone: true,
  imports: [ MatTooltipModule, CSSValuePipe ],
  templateUrl: './switch.html',
  styleUrl: './switch.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Switch),
      multi: true,
    },
  ],
})
export class Switch extends AbstractControl<boolean | undefined, boolean> {
  // Inputs
  override $value = input<boolean | undefined>(undefined, { alias: 'value' });
  $_value = linkedSignal(this.$value);
  $labelLeft = input<string | null>(null, { alias: 'labelLeft' });
  $labelRight = input<string | null>(null, { alias: 'labelRight' });
  $scale = input<number>(1, { alias: 'scale' });
  override $_gap = input<string | undefined>('--gap-small', { alias: 'gap' });

  // Outputs
  override valueChange = output<boolean>();

  // Signals / atributos
  override $controlValue = signal<boolean>(false);

  // Verificar si se emitirá el valor al iniciar
  constructor () {
    super();
    afterNextRender(() => {
      if (this.$emitAtStart()) {
        const value = (this.$value() !== undefined ? this.$value() : this.$controlValue()) as boolean;
        this.valueChange.emit(value);
      }
    });
  }

  // Maneja el evento de cambio de valor desde el input
  onValueChange(event: Event) {
    console.log('Switch onValueChange triggered', event);
    const newValue: boolean = (event.target as HTMLInputElement).checked;
    if (this.$value() !== undefined)
      this.$_value.set(undefined);
    this.updateValue(newValue);
    this.valueChange.emit(newValue);
    console.log('Switch valueChange emitted:', newValue);
  }

  // Maneja el click en el input
  onInputClick(event: MouseEvent) {
    event.stopPropagation();
    console.log('Switch onInputClick triggered');
    const checkbox = event.target as HTMLInputElement;
    const newValue = checkbox.checked;
    console.log('Switch new value:', newValue);
    if (this.$value() !== undefined)
      this.$_value.set(undefined);
    this.updateValue(newValue);
    this.valueChange.emit(newValue);
  }
}
